module.exports = __webpack_public_path__ + "media/images/emblems/Stettlen-coat_of_arms-0aed1cb13dbdad7dbf99b291c73cd562.svg";